import { z } from 'zod'

export const addSwapaggSchema = z.object({
  id_type: z.string().nonempty(),
  trade_date: z.string().nonempty(),
  fortem_id: z.string().nonempty(),
})

export const addSwapaggSchema_FXFWD = addSwapaggSchema.extend({
  bank_id: z.string().nonempty(),
})

export const addSwapaggSchema_ASWAP = addSwapaggSchema.extend({
  bank_id: z.string().nonempty(),
})
